module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 2-b215e5026544be37dc6860841f33324f.jpg";